import { Text } from 'app/design/primitives/text';
import { Trans, useTranslation } from 'react-i18next';
import type { FreeSubParams } from './free-sub';

export function FreeSubHeader({
  finishedTutorial,
  userGotFreeSub,
}: Pick<FreeSubParams, 'finishedTutorial' | 'userGotFreeSub'>) {
  const { t } = useTranslation('free-sub');
  const headerTextKey = finishedTutorial
    ? 'headerTextTutorial'
    : !userGotFreeSub
      ? 'headerTextNotYet'
      : userGotFreeSub === 'trial'
        ? 'headerTextFiveOffers'
        : 'headerText';

  return (
    <>
      <Text style={{ fontSize: 40, fontWeight: '700' }} variant="bodyBase">
        {userGotFreeSub ? t('headerTitle') : t('headerTitleNotYet')}
      </Text>
      <Text style={{ fontSize: 18, fontWeight: '700', textAlign: 'center', marginHorizontal: 15 }} variant="bodyBase">
        <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey={headerTextKey} ns="free-sub" />
      </Text>
      {finishedTutorial ? (
        <Text style={{ fontSize: 18, textAlign: 'center', marginHorizontal: 15 }} variant="bodyBase">
          <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey="subHeaderTextTutorial" ns="free-sub" />
        </Text>
      ) : null}
    </>
  );
}
